import React from 'react';
import AggregataSelector from '../../common/AggregataSelector';
import BetSelector from '../../common/BetSelector';
import FastbetToggle from '../../common/fast-bet/FastbetToggle';
import MacrogruppoSelector from '../../common/MacrogruppoSelector';
import { GROUPED_VIEW_MARKETS } from '../../data/constants';
import { filterMatchesByTimestamp } from '../../data/utils/filterMatchesByTimestamp';
import { filtraParametriche } from '../../data/utils/filtraParametriche';
import { getConfiguration } from '../../data/utils/configuration';
import { groupEventsByDate } from '../../data/utils/groupEventsByDate';
import { labels } from '../../data/labels';
import { PrematchContext } from '../Prematch';
import ExpandedViewToggle from '../../common/ExpandedViewToggle';
import GroupedView from '../../common/GroupedView';
import { TournamentContext } from './TournamentDataFetcher';
import TournamentLiveMatches from './TournamentLiveMatches';
import TournamentMatch from './TournamentMatch';

function TournamentMatches(props) {
    const prematchContext = React.useContext(PrematchContext);
    const tCtx = React.useContext(TournamentContext);
    const conf = getConfiguration();

    function handleExpand() {
        tCtx.setExpanded(!prematchContext.expanded);
    }

    if (tCtx.data.events.length === 0) {
        return (
            <div className="message-box">
                <span className="list-element-text">{labels['general.no_events']}</span>
            </div>
        )
    }

    const tournament = tCtx.data;
    const matches = tournament.events;
    const filteredMatches = filterMatchesByTimestamp(matches, prematchContext.temporalFilter.type);
    const [dates, matchesByDate] = groupEventsByDate(filteredMatches);

    let bets = matches[0].bets.filter(bet => bet.hasOdds);
    bets = filtraParametriche(bets);

    let groupedView = false;
    if (GROUPED_VIEW_MARKETS.includes(bets[0].cs)) {
        groupedView = true;
    }

    const showFastbetToggle = conf.anbe;
    const showExpandedViewToggle = !groupedView && (tCtx.tournament.isLive || bets.length > 1);

    return (
        <>
            {tCtx.macrogruppo ?
                <>
                    {tournament.macrogruppi.length > 1 &&
                        <MacrogruppoSelector macrogruppi={tournament.macrogruppi} macrogruppo={tCtx.macrogruppo.id} changeMacrogruppo={tCtx.changeMacrogruppo.bind(tCtx)} />
                    }
                    {tCtx.macrogruppo.aggregate.length > 1 &&
                        <AggregataSelector betGroups={tCtx.macrogruppo.aggregate} aggregata={tCtx.aggregata} changeBetGroup={tCtx.fetchData.bind(tCtx)} />
                    }
                </>
                :
                <>
                    {tournament.aggregate.length > 1 &&
                        <AggregataSelector betGroups={tournament.aggregate} aggregata={tCtx.aggregata} changeBetGroup={tCtx.changeAggregata.bind(tCtx)} />
                    }
                </>
            }
            {!tCtx.expanded && bets.length > 1 && 
                <BetSelector bets={bets} bet={tCtx.bet ? tCtx.bet : bets[0]} changeBet={tCtx.changeBet.bind(tCtx)} />
            }
            {(showFastbetToggle || showExpandedViewToggle) &&
                <nav id="nav-vista-estesa" className="small">
                    {showFastbetToggle &&
                        <FastbetToggle />
                    }
                    {showExpandedViewToggle &&
                        <div className="d-flex push-right">
                            <label className="custom-switch-2 mr-2">
                                <input type="checkbox" checked={tCtx.expanded === true} onChange={handleExpand} />
                                <span className="custom-slider-2 round"></span>
                            </label>
                            <span>{labels['general.expanded_view']}</span>
                        </div>
                    }
                    {groupedView &&
                        <ExpandedViewToggle />
                    }
                </nav>
            }
            {tCtx.tournament.isLive &&
                <TournamentLiveMatches tournament={tCtx.tournament} />
            }
            {dates.length > 0 ?
                <div id="avvenimenti">
                    {dates.map((d, i) => {
                        const matches = matchesByDate[d];
                        return (
                            <React.Fragment key={i}>
                                <span className="heading text-medium">{matches[0].date}</span>
                                {matches.map((m, j) =>
                                    <React.Fragment key={m.uniqueId}>
                                        {groupedView ?
                                            <GroupedView match={m} bet={m.bets[0]} />
                                            :
                                            <TournamentMatch data={props.data} match={m} aggregata={tCtx.aggregata} bet={tCtx.bet} expanded={tCtx.expanded} />
                                        }
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        )
                    })}
                </div>
                :
                <div className="message-box">
                    <span className="list-element-text">{labels['general.no_events']}</span>
                </div>
            }
        </>
    )
}
export default TournamentMatches;